module.exports = __webpack_public_path__ + "../resources/img/ic_re_arc_standard_glass_img.b3a6d1b6.svg";